import gql from "graphql-tag";

import { boundary, required } from "api/boundary";

import {
  PADDLE_BILLING_PRICES_CONFIGURATION_FRAGMENT,
  PAYMENT_DETAILS_FRAGMENT,
  SUBSCRIPTION_FRAGMENT,
  SUBSCRIPTION_PAGE_FRAGMENT,
} from "./fragments";

export const GET_BILLING_PRICES_CONFIGURATION = {
  query: gql`
    query billingPricesConfiguration($numberUuid: ID!) {
      billingPricesConfiguration(numberUuid: $numberUuid) {
        ...PricesConfigurationDetails
      }
    }

    ${PADDLE_BILLING_PRICES_CONFIGURATION_FRAGMENT}
  `,
  parse: boundary({
    billingPricesConfiguration: {
      paddleConfiguration: required(),
      paddleBillingPrices: boundary({
        id: required(),
        description: required(),
      }),
    },
  }),
};

export const GET_PADDLE_VERSION_CONFIGURATION = {
  query: gql`
    query paddleVersionConfiguration {
      paddleVersionConfiguration
    }
  `,
  parse: boundary({
    paddleVersionConfiguration: required(),
  }),
};

export const GET_NUMBER_BILLING_SUBSCRIPTION_QUERY = gql`
  query getNumberBillingSubscriptionQuery($numberUuid: ID!) {
    number(numberUuid: $numberUuid) {
      ...SubscriptionDetails
    }
  }

  ${SUBSCRIPTION_FRAGMENT}
`;

export const GET_SUBSCRIPTION_PAGE_QUERY = gql`
  query getSubscriptionPageQuery($numberUuid: ID!) {
    number(numberUuid: $numberUuid) {
      ...SubscriptionPageDetails
    }
  }

  ${SUBSCRIPTION_PAGE_FRAGMENT}
`;

export const GET_PAYMENT_DETAILS_QUERY = gql`
  query getPaymentDetailsQuery($numberUuid: ID!) {
    number(numberUuid: $numberUuid) {
      uuid
      subscription {
        ...PaymentNumberSubscriptionDetails
      }
    }
  }

  ${PAYMENT_DETAILS_FRAGMENT}
`;

export const SWITCH_REQUEST_ALREADY_SUBMITTED = gql`
  query switchRequestAlreadySubmitted($subscriptionId: String!) {
    switchRequestAlreadySubmitted(subscriptionId: $subscriptionId)
  }

  ${PAYMENT_DETAILS_FRAGMENT}
`;
